import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import useMarkdownComponents from "../../utils/hooks/useMarkdownComponents";

function Markdown({ content, className, notification, greeting, replied }) {
    const {
        CustomLink,
        CustomH1,
        CustomH2,
        CustomH3,
        CustomDel,
        CustomP,
        CustomBlockQuote,
    } = useMarkdownComponents();

    return (
        <ReactMarkdown
            className={classNames(className, "ek-chat__markdown", {
                "ek-chat__new--header__notification": notification,
                "ek-chat__header--greeting__greeting":
                    !notification && greeting,
                "ek-chat__markdown__replied": replied,
            })}
            components={{
                h1: CustomH1,
                h2: CustomH2,
                h3: CustomH3,
                a: CustomLink,
                del: CustomDel,
                p: CustomP,
                blockquote: CustomBlockQuote,
            }}
            remarkPlugins={[remarkGfm]}
            disallowedElements={["pre", "code"]}
            unwrapDisallowed
        >
            {content}
        </ReactMarkdown>
    );
}

Markdown.propTypes = {
    content: PropTypes.string,
    className: PropTypes.string,
    notification: PropTypes.bool,
    greeting: PropTypes.bool,
    replied: PropTypes.bool,
};

Markdown.defaultProps = {
    content: "",
    className: "",
    notification: false,
    greeting: false,
    replied: false,
};

export default Markdown;
